import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const BackButton = styled.button`
  color: #fff;
  font-family: DM Sans;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
  background: none;
  border: none;
  outline: none;
  width: fit-content;
  cursor: pointer;
  gap: 8px;
  margin-left: -6px;
  letter-spacing: -0.075px;
  margin-top: 16px;
`;

export const Title = styled.h1`
  color: #fff;
  font-family: DM Sans;
  font-size: 26px;
  font-weight: 500;
  letter-spacing: -0.1px;
`;

export const Section = styled.div`
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
  display: flex;
  width: 100%;
  padding: 64px 32px 16px 32px;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  flex-shrink: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 400px;
`;

export const PodiumContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PodiumUsernameWrapper = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
`;

export const PodiumGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const PodiumCard = styled.div`
  border-radius: 20px 20px 4px 4px;

  background: ${(props) =>
    props.$rank === 1
      ? "linear-gradient(213deg, #ffbd25 6.81%, #d87b00 52.91%, #c58300 93.19%)"
      : props.$rank === 2
      ? "linear-gradient(213deg, #8E8E8E 6.81%, #A8A8A8 43.77%, #8E8E8E 93.19%)"
      : props.$rank === 3
      ? "linear-gradient(213deg, #823305 6.81%, #9F430B 43.77%, #893605 93.19%)"
      : "#18181B"};

  box-shadow: ${(props) =>
    props.$rank === 1
      ? "0 1.6px 2.1px 4px #FFDB89 inset"
      : props.$rank === 2
      ? "0 1.6px 3px 0px #DADADA inset"
      : props.$rank === 3
      ? "0 1.6px 3px 0px #EEA14E inset"
      : "none"};

  border: ${(props) =>
    props.$rank === 1
      ? "2.4px solid #FB0"
      : props.$rank === 2
      ? "2.4px solid #AAA"
      : props.$rank === 3
      ? "2.4px solid #813205"
      : "0.5px solid #3d3d45"};

  height: ${(props) =>
    props.$rank === 1
      ? "100px"
      : props.$rank === 2
      ? "80px"
      : props.$rank === 3
      ? "60px"
      : "44px"};

  width: 251px;

  @media (max-width: 840px) {
    width: 150px;
  }

  @media (max-width: 600px) {
    width: 100px;
  }

  display: flex;
  /* padding: 2px 44px 2px 25px; */
  align-items: center;
  gap: 10px;
  outline: none;
  @media (max-width: 389px) {
    width: 90px;
  }
`;

export const PodiumIcon = styled.img`
  width: 32px;
  height: 32px;

  @media (max-width: 840px) {
    width: 14px;
    height: 14px;
  }

  @media (max-width: 600px) {
    width: 14px;
    height: 14px;
  }

  @media (max-width: 389px) {
    width: 14px;
    height: 14px;
  }
`;

export const PodiumColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const PodiumRank = styled.div`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.9px;
  opacity: 0.6;
`;

export const PodiumName = styled.div`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.36px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 231px;

  @media (max-width: 840px) {
    max-width: 120px;
    font-size: 14px;
  }

  @media (max-width: 600px) {
    max-width: 85px;
    font-size: 14px;
  }

  @media (max-width: 389px) {
    width: 60px;
    font-size: 14px;
  }
`;

export const LeaderboardGrid = styled.div`
  display: grid;
  gap: 16px;
  align-self: stretch;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 490px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const LeaderboardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  height: 44px;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;
`;

export const LeaderboardRank = styled.div`
  color: #fff;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.08px;
`;

export const LeaderboardName = styled.div`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  text-transform: lowercase;
  letter-spacing: -0.21px;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmptyStateCard = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
`;
export const TemplateColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: ${(p) => p.$alignItems || "flex-start"};
  gap: ${(p) => p.$gap || 0};
`;

export const TemplateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #18181b")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileTemplateRow = styled.div`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #18181b")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: flex;
  }
`;
export const TemplateLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
  letter-spacing: -0.21px;
`;
export const TemplateValue = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const EmptyStateIcon = styled.div`
  font-size: 48px;
  display: flex;
  justify-content: center;
`;

export const EmptyStateTitle = styled.h3`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const EmptyStateText = styled.p`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const PublishButton = styled.button`
  display: flex;
  width: 180px;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  border-radius: 100px;
  background: #fff;
  align-items: center;
  color: #09090b;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const TemplatesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TemplateFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FooterText = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
`;

export const Pagination = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const PaginationButton = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${(props) =>
    props.disabled ? "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.8)"};
  padding: 8px 16px;
  border-radius: 8px;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  letter-spacing: -0.21px;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.5;
  }
`;

export const PaginationCurrent = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
